export default {
    workflows: {
        title: "Workflow",
        description: "Gestisci workflow personalizzati per gli agenti AI",
        newWorkflow: "Nuovo Workflow",
        searchPlaceholder: "Cerca per nome...",
        statusPlaceholder: "Filtra per stato",
        type: {
            default: "Predefinito",
            custom: "Personalizzato",
        },
        status: {
            draft: "Bozza",
            analyzing: "In Analisi",
            ready: "Pronto",
            needs_clarification: "Da Rivedere",
            invalid: "Non Valido",
            disabled: "Disabilitato",
            // Legacy (for backwards compatibility)
            active: "Attivo",
            inactive: "Inattivo",
        },
        headers: {
            name: "Nome",
            type: "Tipo",
            status: "Stato",
            active: "Attivo",
            nodesCount: "Nodi",
            lastAiEvaluation: "Ultima Validazione AI",
            createdAt: "Creato",
            actions: "Azioni",
        },
        actions: {
            view: "Visualizza",
            edit: "Modifica",
            delete: "Elimina",
        },
        detail: {
            back: "Indietro",
            edit: "Modifica",
            nodesCount: "Nodi",
            edgesCount: "Connessioni",
            createdAt: "Creato il",
            visualization: "Visualizzazione Workflow",
        },
        notFound: {
            title: "Workflow Non Trovato",
            message: "Il workflow richiesto non esiste.",
            backToList: "Torna alla Lista",
        },
        noData: {
            title: "Nessun Workflow",
            message: "Crea il tuo primo workflow per iniziare.",
        },
        modal: {
            confirmDelete: "Elimina Workflow",
            confirmDeleteMessage: "Sei sicuro di voler eliminare questo workflow? Questa azione non può essere annullata.",
            defaultWorkflowWarning: {
                title: "Workflow Predefinito",
                message: "Stai modificando un workflow predefinito. Le modifiche potrebbero influenzare il comportamento del sistema.",
            },
            deleteDefaultWorkflow: {
                title: "Elimina Workflow Predefinito",
                message: "Stai per eliminare un workflow predefinito. Questa azione potrebbe influenzare il comportamento del sistema. Sei sicuro di voler continuare?",
            },
        },
        new: {
            title: "Nuovo Workflow",
        },
        edit: {
            title: "Modifica Workflow",
        },
        editor: {
            addNode: "Aggiungi Nodo",
            deleteNode: "Elimina Nodo",
            cancel: "Annulla",
            save: "Salva",
            nodeProperties: "Proprietà Nodo",
            nodeType: "Tipo",
            nodeLabel: "Label",
            agentType: "Tipo Agente",
            actionType: "Tipo Azione",
            condition: "Condizione",
            nodeTypes: {
                start: "Nodo Start",
                agent: "Nodo Agente",
                decision: "Nodo Decisione",
                action: "Nodo Azione",
                email: "Nodo Email",
                end: "Nodo End",
            },
            defaultLabels: {
                start: "Start",
                agent: "Agente",
                decision: "Decisione",
                action: "Azione",
                email: "Email",
                end: "End",
            },
            agentTypes: {
                postino: "Postino/Mailer",
                classificatore: "Classificatore",
                parser: "Parser",
                validatore: "Validatore",
            },
            actionTypes: {
                notification_in_app: "Notifica In-App",
                notification_email: "Notifica Email",
                notification_both: "Notifica Completa",
            },
            operators: {
                equals: "Uguale",
                contains: "Contiene",
                exists: "Esiste",
                not_equals: "Non Uguale",
                not_contains: "Non Contiene",
            },
            savingWorkflow: "Salvataggio workflow...",
            workflowSaved: "Workflow salvato con successo!",
            relatedAccounts: "Account Correlati",
            searchAccounts: "Cerca account per nome, email o partita IVA...",
            noAccountsFound: "Nessun account trovato",
            taxId: "Partita IVA",
            selectedCount: "{{count}} selezionati",
            close: "Chiudi",
            instructions: "Istruzioni (Linguaggio Naturale)",
            instructionsPlaceholder: "Descrivi la condizione o l'azione in linguaggio naturale...",
            edgeProperties: "Proprietà Connessione",
            edgeLabel: "Etichetta",
            edgeLabelPlaceholder: "Inserisci etichetta per la connessione...",
            deleteEdge: "Elimina Connessione",
            closeSidebar: "Chiudi pannello",
            openSidebar: "Apri pannello",
            workflowProperties: "Proprietà Workflow",
            status: "Stato",
            isActive: "Attivo",
            isDefault: "Workflow Predefinito",
            evaluate: "Valuta",
            evaluating: "Valutazione...",
            agentDefault: "Predefinito",
            agentSelector: {
                placeholder: "Seleziona un agente...",
                searchPlaceholder: "Cerca agente per nome, descrizione...",
                filters: {
                    all: "Tutti",
                    defaultOnly: "Solo predefiniti",
                },
                noResults: "Nessun agente trovato",
                tools: "{{count}} strumenti",
                ragSources: "{{count}} fonti RAG",
            },
            aiFeedback: {
                title: "Risultati Valutazione AI",
                analyzedAt: "Analizzato il",
                nodeId: "Nodo",
                suggestions: "Suggerimenti",
                noFeedback: "Nessun feedback disponibile. Clicca 'Valuta' per analizzare questo workflow.",
            },
            // Start Node - Trigger Configuration
            triggerType: "Tipo Trigger",
            selectTrigger: "Seleziona un trigger...",
            requiresConditions: "richiede condizioni",
            triggerConditions: "Condizioni Trigger",
            selectValue: "Seleziona un valore...",
            startNodeInstruction: "Descrizione",
            startNodeInstructionPlaceholder: "Descrivi cosa fa questo workflow e quando si attiva...",
            // Action Node - Actions Configuration
            availableActions: "Azioni Disponibili",
            addAction: "Aggiungi Azione",
            actionOrder: "Ordine",
            actionParams: "Parametri",
            actionParamsPlaceholder: "Configura i parametri dell'azione...",
            noActionsConfigured: "Nessuna azione configurata. Clicca 'Aggiungi Azione' per aggiungere azioni al workflow.",
            removeAction: "Rimuovi",
            moveUp: "Sposta Su",
            moveDown: "Sposta Giù",
            actionCategories: {
                notification: "Notifiche",
                logging: "Log e Attività",
                data_query: "Query Dati",
                document: "Documenti",
                tracking: "Tracking",
                external: "Servizi Esterni",
                delegation: "Delegazione",
            },
            dangerousAction: "Pericolosa",
            requiresConfirmation: "Richiede Conferma",
            toolAction: "Tool",
            // Email Node
            emailNodeTemplateFilter: "Filtro template",
            emailNodeFilterSystem: "Solo template di sistema",
            emailNodeFilterCompany: "Template per company",
            emailNodeSelectTemplate: "Seleziona template",
            emailNodeCompany: "Company",
            emailNodeSelectCompany: "Seleziona company...",
            emailNodeRules: "Regole (linguaggio naturale)",
            emailNodeRulesPlaceholder: "Descrivi le regole da seguire per questo invio email...",
            emailNodeTo: "Destinatari (opzionale)",
            emailNodeToPlaceholder: "es. {{context.email_to}} o indirizzi separati da virgola",
        },
        savingChanges: "Salvataggio in corso...",
        allSaved: "Tutto salvato!",
    },
};
